module.exports = __webpack_public_path__ + "static/media/loreal0logo.0edd52ec.jpg";